var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "expert-list-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-avatar', {
    attrs: {
      "width": "18rem",
      "height": "12rem",
      "tile": "",
      "color": "grey lighten-4"
    }
  }, [_vm.expert._avatar ? _c('v-img', {
    attrs: {
      "src": _vm.expert.avatar.url,
      "alt": "".concat(_vm.expert.companyName, " \uB85C\uACE0"),
      "contain": ""
    }
  }) : _vm.isOrganization ? _c('v-icon', {
    attrs: {
      "size": "4rem"
    }
  }, [_vm._v("mdi-domain")]) : _vm.isSupporter ? _c('v-icon', {
    attrs: {
      "size": "4rem"
    }
  }, [_vm._v("mdi-account")]) : _vm._e()], 1)], 1), _c('v-col', {
    staticClass: "expert-item-texts"
  }, [_c('item-area-badges', {
    attrs: {
      "areas": _vm.expert.areas
    }
  }), _vm.expert.companyName ? _c('div', {
    staticClass: "text-h6 line-height-1"
  }, [_vm._v(_vm._s(_vm.expert.companyName))]) : _vm._e(), _vm.expert.nickname ? _c('div', {
    staticClass: "text-h6 line-height-1"
  }, [_vm._v(_vm._s(_vm.expert.nickname))]) : _vm._e(), _vm.expert.summary ? _c('div', {
    staticClass: "expert-item-summary"
  }, [_vm._v(_vm._s(_vm.expert.summary))]) : _vm._e(), _c('data-list', {
    attrs: {
      "dataList": _vm.description,
      "isOnList": "",
      "disableNoneMessage": _vm.isSupporter
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "rounded-0",
    attrs: {
      "href": _vm.href,
      "outlined": "",
      "color": "primary"
    }
  }, [_vm._v("상세보기")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }